import {
  createStyles,
  Grid,
  withStyles,
  type WithStyles,
} from "@material-ui/core";
import { InfoRounded } from "@material-ui/icons";
import { useTranslations } from "adapters/i18n";
import SelectDropdown from "components/SelectDropdown";
import React, { useState } from "react";
import type { ConfigurationOptionFeature } from "../configurations.types";
import { ConfigurationFeature } from "../utils/configurations.utils";
import FeatureDisclaimerModal from "./featureDisclaimerModal";

type FeaturesDropdownProps = {
  items: ConfigurationOptionFeature[];
  onFeatureChange: (feature: ConfigurationFeature) => void;
  selectedFeature: ConfigurationFeature;
  selectedFeatureItem: ConfigurationOptionFeature;
} & WithStyles<typeof styles>;

function FeaturesDropdown({
  classes,
  items,
  onFeatureChange,
  selectedFeature,
  selectedFeatureItem,
}: FeaturesDropdownProps) {
  const { t } = useTranslations();

  const [isDisclaimerModalOpen, setIsDisclaimerModalOpen] =
    useState<boolean>(false);

  const options = items.map((item) => ({
    value: item.id,
    label: item.label,
  }));

  const showDisclaimerTrigger = ![
    ConfigurationFeature.ALL,
    ConfigurationFeature.ARROBA_BALANCE,
  ].includes(selectedFeature);

  const handleClickInfoIcon = () => {
    setIsDisclaimerModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsDisclaimerModalOpen(false);
  };

  const handleSelectItem = (value: ConfigurationFeature) => {
    onFeatureChange(value);
  };

  return (
    <React.Fragment>
      <Grid container alignItems="center">
        <Grid item xs={3} className={classes.selectWrapper}>
          <SelectDropdown
            id="feature-filter"
            label={{ text: t("configurations:filter-by-features") }}
            options={options}
            value={selectedFeature}
            onChange={handleSelectItem}
          />
        </Grid>
        {showDisclaimerTrigger && (
          <Grid item xs={2} className={classes.infoIconWrapper}>
            <InfoRounded
              className={classes.infoIcon}
              color="primary"
              data-testid="disclaimer-modal-trigger"
              onClick={handleClickInfoIcon}
            />
          </Grid>
        )}
      </Grid>
      <FeatureDisclaimerModal
        description={selectedFeatureItem.modalDescription}
        isOpen={isDisclaimerModalOpen}
        onClose={handleCloseModal}
        title={selectedFeatureItem.label}
      />
    </React.Fragment>
  );
}

const styles = () =>
  createStyles({
    selectWrapper: {
      paddingTop: "16px",
      marginLeft: "14px",
    },
    infoIconWrapper: {
      marginLeft: "12px",
      marginTop: "30px",
    },
    infoIcon: {
      fontSize: "24px !important",
      cursor: "pointer",
    },
  });

export default withStyles(styles)(FeaturesDropdown);
